import { render, staticRenderFns } from "./ColumnSelectorDialog.vue?vue&type=template&id=061f03b0&"
import script from "./ColumnSelectorDialog.vue?vue&type=script&lang=js&"
export * from "./ColumnSelectorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports